/*
Sectioned-page sidebar (Risk Factors pattern): scrollspy highlighting for the
auto-generated anchor nav rendered by template-parts/section_sections.php.
Active = the last section heading above the reading line (25% viewport), so
long sections stay highlighted while being read.
*/

document.querySelectorAll("[data-section-nav]").forEach((section) => {
  const nav = section.querySelector(".section-nav");
  const toggle = section.querySelector(".section-nav__toggle");
  if (nav && toggle) {
    const setOpen = (open) => {
      nav.classList.toggle("is-open", open);
      toggle.setAttribute("aria-expanded", String(open));
    };
    toggle.addEventListener("click", () =>
      setOpen(!nav.classList.contains("is-open"))
    );
    // Selecting a section, clicking away or Escape all close the panel.
    nav.addEventListener("click", (e) => {
      if (e.target.closest(".section-nav__panel a")) setOpen(false);
    });
    document.addEventListener("click", (e) => {
      if (!nav.contains(e.target)) setOpen(false);
    });
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") setOpen(false);
    });

    // KWB-83: the V3 navbar no longer hides on scroll, so the observer that
    // mirrored .nav-hidden onto this pill has been removed — the pill simply
    // stays offset below the bar, which is always visible.
  }

  const links = [...section.querySelectorAll(".section-nav a[href^='#']")];
  const targets = links
    .map((a) => document.getElementById(decodeURIComponent(a.hash.slice(1))))
    .filter(Boolean);
  if (!targets.length) return;

  const linkFor = new Map(targets.map((t, i) => [t, links[i]]));
  let activeLink = null;

  const update = () => {
    const line = window.innerHeight * 0.25;
    let current = targets[0];
    targets.forEach((t) => {
      if (t.getBoundingClientRect().top <= line) current = t;
    });
    const link = linkFor.get(current);
    if (link !== activeLink) {
      links.forEach((a) => a.classList.toggle("is-active", a === link));
      activeLink = link;
    }
  };

  let ticking = false;
  window.addEventListener(
    "scroll",
    () => {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(() => {
          ticking = false;
          update();
        });
      }
    },
    { passive: true }
  );
  window.addEventListener("resize", update, { passive: true });
  update();
});
